import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { hrmUserRoles } from "../hrmModulesData";

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

const HrmRolesSection: React.FC = () => {
  return (
    <section className="hms-roles hrm-roles" aria-labelledby="hrm-roles-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="hrm-roles-title" className="wdev-section-head__title">
            User Roles &amp; Access
          </h2>
          <p className="hms-roles__lead">
            Role-based access for admin, HR managers, department managers, and employees — each
            with tailored functionality for their responsibilities.
          </p>
        </AnimatedSection>

        <div className="hms-roles__grid">
          {hrmUserRoles.map((role, index) => (
            <motion.article
              key={role.title}
              className="hms-roles-card"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
              custom={index}
              variants={cardVariants}
            >
              <h3 className="hms-roles-card__title">{role.title}</h3>
              <p className="hms-roles-card__intro">{role.intro}</p>
              <ul className="hms-roles-card__list">
                {role.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HrmRolesSection;
